<template>
    <div v-if="paymentMethods && paymentMethods.payment_link" class="pt-2">
        <p>
            Será gerado um link para pagamento posterior através de
            <b>Cartão de Crédito</b>. Após realizar o pagamento utilizando o link gerado, o pedido
            será confirmado automaticamente.
        </p>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentLink',

        props: ['cart', 'customer', 'paymentMethods'],

        computed: {
            description() {
                return 'Link de Pagamento';
            },
        },

        methods: {
            submit(callback) {
                callback({
                    module: 'cartoesdecredito',
                    installments: 0,
                    payment_link: true,
                });
            },
        },
    };
</script>
